import {
  Block,
  LabelSmall,
  ParagraphSmall,
  Skeleton,
  useStyletron,
} from "@mezo-org/mezo-clay"

import {
  selectHasLoadedWalletBalances,
  selectIsBorrowLoadingData,
  selectUserHasLoan,
  selectWalletBalances,
  useDappSelector,
} from "#/redux-state"
import {
  useMaxBorrowAmount,
  useMinimumRequiredCollateralForNewLoan,
} from "#/shared/hooks"
import { bigIntToCommaSeparatedFloat } from "#/shared/utils"

export default function HomepageMainSectionAssetsBorrowAmount() {
  const { mBTC } = useDappSelector(selectWalletBalances)
  const hasLoan = useDappSelector(selectUserHasLoan)

  const hasLoadedWalletBalances = useDappSelector(selectHasLoadedWalletBalances)
  const isLoadingBorrowData = useDappSelector(selectIsBorrowLoadingData)

  const [, theme] = useStyletron()

  const {
    maxEligibleCredit,
    potentialMaxEligibleCredit,
    potentialMbtcBalance,
  } = useMaxBorrowAmount()

  const { requiredCollateralAmount } = useMinimumRequiredCollateralForNewLoan()

  if (isLoadingBorrowData || !hasLoadedWalletBalances) {
    return (
      <Block paddingTop={theme.sizing.scale100}>
        <Skeleton
          width={theme.sizing.scale2400}
          height={theme.sizing.scale600}
          animation
        />
      </Block>
    )
  }

  if (hasLoan) {
    return (
      <ParagraphSmall
        color="contentSecondary"
        display="inline-block"
        data-attr="has_loan"
      >
        from 1 loan
      </ParagraphSmall>
    )
  }

  if (!hasLoan && mBTC.balance >= requiredCollateralAmount) {
    return (
      <>
        <ParagraphSmall
          color="contentSecondary"
          display="inline-block"
          data-attr="has_mbtc"
        >
          Borrow up to
        </ParagraphSmall>{" "}
        <LabelSmall color="contentSecondary" display="inline-block">
          {bigIntToCommaSeparatedFloat(maxEligibleCredit ?? 0n)} MUSD
        </LabelSmall>{" "}
      </>
    )
  }

  if (!hasLoan && potentialMbtcBalance >= requiredCollateralAmount) {
    return (
      <>
        <ParagraphSmall
          color="contentSecondary"
          display="inline-block"
          data-attr="no_mbtc"
        >
          Borrow up to
        </ParagraphSmall>{" "}
        <LabelSmall color="contentSecondary" display="inline-block">
          {bigIntToCommaSeparatedFloat(potentialMaxEligibleCredit ?? 0n)} MUSD
        </LabelSmall>{" "}
      </>
    )
  }

  // If user does not have any MUSD we don't show the calculations
  return null
}
